import { render, staticRenderFns } from "./addNewGoods.vue?vue&type=template&id=699bc4c2&scoped=true&"
import script from "./addNewGoods.vue?vue&type=script&lang=js&"
export * from "./addNewGoods.vue?vue&type=script&lang=js&"
import style0 from "./addNewGoods.vue?vue&type=style&index=0&id=699bc4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699bc4c2",
  null
  
)

export default component.exports